
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const CasesPage: React.FC = () => {
  const cases = [
    {
      title: '한강대교 구조물 안전 모니터링',
      category: '교량',
      client: '서울시설공단',
      period: '2022.03 - 현재',
      description: '한강대교의 실시간 구조 건전성 모니터링 시스템 구축으로 교량 안전성 확보',
      features: ['변형률 센서 120개', '가속도 센서 40개', '실시간 모니터링', 'AI 이상 감지'],
      results: ['사고 예방 100%', '유지보수 비용 30% 절감', '교통 안전성 향상'],
      image: 'https://public.readdy.ai/ai/img_res/0e63fbc3ad42f11da33a819c667ca5aa.jpg'
    },
    {
      title: '인천국제공항 제2터미널 지반 모니터링',
      category: '공항',
      client: '인천국제공항공사',
      period: '2021.06 - 2023.12',
      description: '대규모 공항 건설 현장의 지반 침하 및 안정성 실시간 모니터링',
      features: ['침하계 200개', '경사계 80개', '간극수압계 150개', '자동 알림 시스템'],
      results: ['지반 안정성 확보', '공사 기간 단축 15%', '품질 관리 강화'],
      image: 'https://readdy.ai/api/search-image?query=Incheon%20Airport%20Terminal%202%20ground%20monitoring%2C%20settlement%20monitoring%20equipment%2C%20construction%20site%20monitoring%2C%20airport%20construction%20project%2C%20professional%20geotechnical%20monitoring%2C%20blue%20and%20white%20color%20scheme&width=600&height=400&seq=incheon-airport&orientation=landscape'
    },
    {
      title: '부산 해운대 터널 굴착 모니터링',
      category: '터널',
      client: '부산교통공사',
      period: '2020.09 - 2022.08',
      description: '도심지 터널 굴착 시 주변 구조물 및 지반 변형 모니터링',
      features: ['변위계 300개', '진동 센서 100개', '지하수위 모니터링', '3D 변형 분석'],
      results: ['주변 건물 안전 확보', '굴착 효율성 20% 향상', '민원 발생 제로'],
      image: 'https://readdy.ai/api/search-image?query=Busan%20Haeundae%20tunnel%20excavation%20monitoring%2C%20underground%20construction%20monitoring%2C%20tunnel%20boring%20machine%2C%20displacement%20sensors%2C%20professional%20tunnel%20construction%2C%20blue%20and%20white%20color%20scheme&width=600&height=400&seq=busan-tunnel&orientation=landscape'
    },
    {
      title: '송도 국제업무단지 스마트시티 통합 모니터링',
      category: '스마트시티',
      client: '인천경제자유구역청',
      period: '2019.01 - 현재',
      description: '스마트시티 인프라의 통합 환경 및 안전 모니터링 시스템',
      features: ['환경 센서 500개', 'IoT 통합 플랫폼', '빅데이터 분석', '시민 서비스 연계'],
      results: ['환경 품질 개선', '에너지 효율 25% 향상', '시민 만족도 증가'],
      image: 'https://readdy.ai/api/search-image?query=Songdo%20Smart%20City%20integrated%20monitoring%20system%2C%20smart%20city%20infrastructure%2C%20environmental%20monitoring%2C%20IoT%20sensors%20network%2C%20modern%20urban%20development%2C%20blue%20and%20white%20color%20scheme&width=600&height=400&seq=songdo-smartcity&orientation=landscape'
    },
    {
      title: '울산 석유화학단지 안전 모니터링',
      category: '산업시설',
      client: 'SK에너지',
      period: '2021.03 - 현재',
      description: '대규모 석유화학 플랜트의 실시간 안전 및 환경 모니터링',
      features: ['가스 센서 400개', '화재 감지 시스템', '실시간 대기질 모니터링', '비상 대응 시스템'],
      results: ['사고 예방 효과', '환경 규제 준수', '운영 효율성 향상'],
      image: 'https://readdy.ai/api/search-image?query=Ulsan%20petrochemical%20complex%20safety%20monitoring%2C%20industrial%20plant%20monitoring%20system%2C%20gas%20detection%20sensors%2C%20safety%20monitoring%20equipment%2C%20chemical%20plant%20infrastructure%2C%20blue%20and%20white%20color%20scheme&width=600&height=400&seq=ulsan-petrochemical&orientation=landscape'
    },
    {
      title: '세종시 정부청사 건설 현장 통합 모니터링',
      category: '정부청사',
      client: '국토교통부',
      period: '2020.01 - 2022.12',
      description: '대규모 정부청사 건설 현장의 종합적인 안전 및 환경 관리',
      features: ['통합 센서 네트워크', '작업자 안전 모니터링', '소음/진동 관리', '공정 관리 시스템'],
      results: ['무사고 달성', '공기 단축 10%', '환경 영향 최소화'],
      image: 'https://readdy.ai/api/search-image?query=Sejong%20Government%20Complex%20construction%20monitoring%2C%20large%20scale%20construction%20site%20monitoring%2C%20government%20building%20construction%2C%20comprehensive%20safety%20monitoring%2C%20blue%20and%20white%20color%20scheme&width=600&height=400&seq=sejong-government&orientation=landscape'
    }
  ];

  const stats = [
    { number: '500+', label: '완료 프로젝트', icon: 'ri-building-line' },
    { number: '50+', label: '파트너 기업', icon: 'ri-team-line' },
    { number: '99.9%', label: '시스템 안정성', icon: 'ri-shield-check-line' },
    { number: '15년', label: '업계 경험', icon: 'ri-time-line' }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">
                적용 사례
              </h1>
              <p className="text-xl mb-8 leading-relaxed">
                다양한 건설 현장에서 검증된 통합 자동화 계측 시스템의 
                성공적인 적용 사례를 소개합니다.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
                {stats.map((stat, index) => (
                  <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                      <i className={`${stat.icon} text-2xl`}></i>
                    </div>
                    <div className="text-3xl font-bold mb-2">{stat.number}</div>
                    <div className="text-sm opacity-90">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 주요 적용 사례 */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                주요 적용 사례
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                국내 대형 인프라 프로젝트에서 입증된 기술력과 신뢰성
              </p>
            </div>

            <div className="space-y-16">
              {cases.map((caseItem, index) => (
                <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium inline-block mb-4">
                      {caseItem.category}
                    </div>
                    <h3 className="text-3xl font-bold text-gray-800 mb-4">
                      {caseItem.title}
                    </h3>
                    <div className="grid grid-cols-2 gap-4 mb-6 text-sm">
                      <div>
                        <span className="font-medium text-gray-600">발주처:</span>
                        <div className="text-gray-800">{caseItem.client}</div>
                      </div>
                      <div>
                        <span className="font-medium text-gray-600">기간:</span>
                        <div className="text-gray-800">{caseItem.period}</div>
                      </div>
                    </div>
                    <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                      {caseItem.description}
                    </p>
                    
                    <div className="mb-6">
                      <h4 className="font-semibold text-gray-800 mb-3">주요 기능</h4>
                      <div className="flex flex-wrap gap-2">
                        {caseItem.features.map((feature, idx) => (
                          <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-3">주요 성과</h4>
                      <ul className="space-y-2">
                        {caseItem.results.map((result, idx) => (
                          <li key={idx} className="flex items-center text-gray-600">
                            <i className="ri-check-line text-green-600 mr-2"></i>
                            {result}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                    <div 
                      className="h-96 bg-cover bg-center rounded-lg shadow-lg"
                      style={{ backgroundImage: `url(${caseItem.image})` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 분야별 적용 현황 */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                분야별 적용 현황
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                다양한 건설 분야에서 축적된 풍부한 경험과 노하우
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-2-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">교량/터널</h3>
                <div className="text-3xl font-bold text-blue-600 mb-2">150+</div>
                <p className="text-gray-600 text-sm">프로젝트 완료</p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">건축</h3>
                <div className="text-3xl font-bold text-blue-600 mb-2">200+</div>
                <p className="text-gray-600 text-sm">프로젝트 완료</p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-road-map-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">도로/철도</h3>
                <div className="text-3xl font-bold text-blue-600 mb-2">100+</div>
                <p className="text-gray-600 text-sm">프로젝트 완료</p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-factory-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">산업시설</h3>
                <div className="text-3xl font-bold text-blue-600 mb-2">50+</div>
                <p className="text-gray-600 text-sm">프로젝트 완료</p>
              </div>
            </div>
          </div>
        </section>

        {/* 고객 평가 */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">
                고객 평가
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                프로젝트 파트너들의 생생한 후기와 평가
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 mb-4 italic">
                  "실시간 모니터링 시스템 덕분에 교량 안전성을 크게 향상시킬 수 있었습니다. 
                  특히 AI 기반 이상 감지 기능이 매우 유용했습니다."
                </p>
                <div className="font-semibold text-gray-800">김현수 과장</div>
                <div className="text-sm text-gray-600">서울시설공단</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 mb-4 italic">
                  "지반 모니터링 시스템의 정확성과 안정성이 뛰어났습니다. 
                  대규모 프로젝트에서도 문제없이 운영되었습니다."
                </p>
                <div className="font-semibold text-gray-800">이지영 팀장</div>
                <div className="text-sm text-gray-600">인천국제공항공사</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 mb-4 italic">
                  "모바일 앱을 통한 현장 관리가 매우 편리했습니다. 
                  언제 어디서나 실시간으로 현장 상황을 파악할 수 있어 좋았습니다."
                </p>
                <div className="font-semibold text-gray-800">박민호 부장</div>
                <div className="text-sm text-gray-600">부산교통공사</div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600 text-white">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold mb-6">
              귀하의 프로젝트에도 적용해보세요
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              검증된 기술력과 풍부한 경험을 바탕으로 최적의 솔루션을 제공해드립니다.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="#contact" 
                className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                프로젝트 상담
              </a>
              <a 
                href="/overview" 
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                시스템 개요 보기
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CasesPage;
